export const getWhatsAppUrl = (text: string) => `https://api.whatsapp.com/send?text=${encodeURIComponent(text)}`
